import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/map.svg'


const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "ps-0 mb-0 list-unstyled sales_by_locations mt-4" }
const _hoisted_4 = { class: "flex-shrink-0" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "flex-grow-1 ms-3" }
const _hoisted_7 = { class: "fw-medium d-block mb-2" }
const _hoisted_8 = ["aria-valuenow"]
const _hoisted_9 = { class: "count fw-medium text-body" }

import { onMounted } from "vue";
import feather from "feather-icons";


export default /*@__PURE__*/_defineComponent({
  __name: 'SalesByLocations',
  setup(__props) {

const countries = [
  {
    name: "United States",
    image: require("@/assets/images/usa.svg"),
    progress: 85,
  },
  {
    name: "Germany",
    image: require("@/assets/images/germany.svg"),
    progress: 75,
  },
  {
    name: "United Kingdom",
    image: require("@/assets/images/united-kingdom.svg"),
    progress: 40,
  },
  {
    name: "Canada",
    image: require("@/assets/images/canada.svg"),
    progress: 10,
  },
  {
    name: "Portugal",
    image: require("@/assets/images/portugal.svg"),
    progress: 5,
  },
  {
    name: "Spain",
    image: require("@/assets/images/spain.svg"),
    progress: 15,
  },
];
onMounted(() => {
  feather.replace();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4\"><h3 class=\"mb-0\">Sales by Locations</h3><div class=\"dropdown action-opt\"><button class=\"btn bg-transparent p-0\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i data-feather=\"more-horizontal\"></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"clock\"></i> Today </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"pie-chart\"></i> Last 7 Days </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"rotate-cw\"></i> Last Month </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"calendar\"></i> Last 1 Year </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"bar-chart\"></i> All Time </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"eye\"></i> View </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash\"></i> Delete </a></li></ul></div></div><div class=\"text-center mb-4\"><img src=\"" + _imports_0 + "\" alt=\"map\"></div>", 2)),
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(countries, (country, index) => {
          return _createElementVNode("li", {
            class: "d-flex align-items-center",
            key: index
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: country.image,
                class: "wh-30 rounded-circle",
                alt: country.name
              }, null, 8, _hoisted_5)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(country.name), 1),
              _createElementVNode("div", {
                class: "progress",
                role: "progressbar",
                "aria-valuenow": country.progress,
                "aria-valuemin": "0",
                "aria-valuemax": "100"
              }, [
                _createElementVNode("div", {
                  class: "progress-bar",
                  style: _normalizeStyle({ width: country.progress + '%' })
                }, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(country.progress) + "% ", 1)
                ], 4)
              ], 8, _hoisted_8)
            ])
          ])
        }), 64))
      ])
    ])
  ]))
}
}

})